import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory';

import './App.css';

// import Home from './pages/Home/Home.page';
import FevereiroRoxo from './pages/FevereiroRoxo/FevereiroRoxo.page.jsx';
import OutubroRosa from './pages/OutubroRosa/OutubroRosa.page.jsx';
import MarcoAzulMarinho from './pages/MarcoAzulMarinho/MarcoAzulMarinho.page.jsx';
import AbrilAzul from './pages/AbrilAzul/AbrilAzul.page.jsx';
import IframeMedicos from './pages/Iframe/Medicos/IframeMedicos.page.jsx';
import IframeCobertura from './pages/Iframe/PlanosDeSaude/IframeCobertura.page.jsx';
import CanalColaborador from './pages/CanalColaborador/CanalColaborador.page.jsx';
import CanalBioEtica from './pages/CanalBioEtica/CanalBioEtica.page';
import Elogios from './pages/Elogios/Elogios.page.jsx';



const history = createHistory()

const App = () => {
  return (
    <Router history={history}>
      <div className="App">
        <Switch>
          <Route exact path="/canal-de-bioetica" component={CanalBioEtica} />
          <Route exact path="/canal-do-colaborador" component={CanalColaborador} />
          <Route exact path="/elogios" component={Elogios} />
          {/* <Route exact path="/fevereiro-roxo" component={FevereiroRoxo} />
          <Route exact path="/outubro-rosa" component={OutubroRosa} />
          <Route exact path="/marco-azul-marinho" component={MarcoAzulMarinho} />
          <Route exact path="/abril-azul" component={AbrilAzul} /> */}
          <Route exact path="/iframe/medicos" component={IframeMedicos} />
          <Route exact path="/iframe/planos" component={IframeCobertura} />
          <Route exact path="/"  component={() => { window.location.href = "https://hospitalsaocamilosp.org.br/"; return null; }} />
          {/* <Route component={Home} /> */}
        </Switch>
      </div>
    </Router>
  );
}

export default App;